/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeliveryFeeDto } from './DeliveryFeeDto';
import {
    DeliveryFeeDtoFromJSON,
    DeliveryFeeDtoFromJSONTyped,
    DeliveryFeeDtoToJSON,
} from './DeliveryFeeDto';
import type { DeliveryDtoAppliedPromotion } from './DeliveryDtoAppliedPromotion';
import {
    DeliveryDtoAppliedPromotionFromJSON,
    DeliveryDtoAppliedPromotionFromJSONTyped,
    DeliveryDtoAppliedPromotionToJSON,
} from './DeliveryDtoAppliedPromotion';

/**
 * 
 * @export
 * @interface DeliveryDto
 */
export interface DeliveryDto {
    /**
     * Delivery ID
     * @type {number}
     * @memberof DeliveryDto
     */
    id: number;
    /**
     * Delivery type
     * @type {string}
     * @memberof DeliveryDto
     */
    type: DeliveryDtoTypeEnum;
    /**
     * Delivery description in English
     * @type {number}
     * @memberof DeliveryDto
     */
    descriptionEn?: number;
    /**
     * Delivery description in Arabic
     * @type {number}
     * @memberof DeliveryDto
     */
    descriptionAr?: number;
    /**
     * Delivery fee actually charged for this delivery/currency. When a waiver applies this is 0 and originalDeliveryFee shows what would have been charged.
     * @type {Array<DeliveryFeeDto>}
     * @memberof DeliveryDto
     */
    deliveryFee: Array<DeliveryFeeDto>;
    /**
     * Fee before any waiver was applied. Only set on user-facing (currency-scoped) reads when a promotion zeroes the fee.
     * @type {number}
     * @memberof DeliveryDto
     */
    originalDeliveryFee?: number;
    /**
     * 
     * @type {DeliveryDtoAppliedPromotion}
     * @memberof DeliveryDto
     */
    appliedPromotion?: DeliveryDtoAppliedPromotion;
    /**
     * Timestamp delivery was created at
     * @type {Date}
     * @memberof DeliveryDto
     */
    createdAt: Date;
    /**
     * Timestamp delivery was updated at
     * @type {Date}
     * @memberof DeliveryDto
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const DeliveryDtoTypeEnum = {
    Asap: 'ASAP',
    SameDay: 'SAME_DAY',
    NextDay: 'NEXT_DAY',
    InTwoDays: 'IN_TWO_DAYS'
} as const;
export type DeliveryDtoTypeEnum = typeof DeliveryDtoTypeEnum[keyof typeof DeliveryDtoTypeEnum];


/**
 * Check if a given object implements the DeliveryDto interface.
 */
export function instanceOfDeliveryDto(value: object): value is DeliveryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('deliveryFee' in value) || value['deliveryFee'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function DeliveryDtoFromJSON(json: any): DeliveryDto {
    return DeliveryDtoFromJSONTyped(json, false);
}

export function DeliveryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'descriptionEn': json['descriptionEn'] == null ? undefined : json['descriptionEn'],
        'descriptionAr': json['descriptionAr'] == null ? undefined : json['descriptionAr'],
        'deliveryFee': ((json['deliveryFee'] as Array<any>).map(DeliveryFeeDtoFromJSON)),
        'originalDeliveryFee': json['originalDeliveryFee'] == null ? undefined : json['originalDeliveryFee'],
        'appliedPromotion': json['appliedPromotion'] == null ? undefined : DeliveryDtoAppliedPromotionFromJSON(json['appliedPromotion']),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function DeliveryDtoToJSON(value?: DeliveryDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'type': value['type'],
        'descriptionEn': value['descriptionEn'],
        'descriptionAr': value['descriptionAr'],
        'deliveryFee': ((value['deliveryFee'] as Array<any>).map(DeliveryFeeDtoToJSON)),
        'originalDeliveryFee': value['originalDeliveryFee'],
        'appliedPromotion': DeliveryDtoAppliedPromotionToJSON(value['appliedPromotion']),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

